import React, {useContext, useState} from "react"
import PropTypes from "prop-types"
import {useRouter} from "next/router"
import FilterContext from "../../../context/FilterContext"
import {FilterItemProps} from "./props/FilterProps"
import {getParamValuesArray} from "../utility/Utility"
import {defaultValue} from "../Config"
import {filterUrl} from "../FilterUrl"
import {gaCategories, gaEvents} from "../../../config/googleAnalytics/events"
import Checkbox from "../../reusable/components/Checkbox/Checkbox"
import AnalyticsContext from "../../../context/AnalyticsContext"
import {useTranslation} from "next-i18next"
import {CollectionName} from "../../../constants"
import DataContext from "../../../context/DataContext"

const FilterDropdownItem: React.FC<FilterItemProps> = ({
	label,
	param,
	value,
	isBoxShape = false,
	collectionName,
	customUrlBaseValue,
	labelOnly = false,
	className,
	styles,
	isSwissMade,
	link
}) => {
	const router = useRouter()
	const {brandWorld} = useContext(DataContext)
	const {page, ...params} = router.query
	const [loading, setLoading] = useState(false)
	const {filtersLoading, setFiltersLoading} = useContext(FilterContext)
	const {t} = useTranslation(["common", "filters"])
	const {reactGA} = useContext(AnalyticsContext)
	const isBrandWorld = router.pathname.includes("/brand-world")
	const handleChange = () => {
		setFiltersLoading(true)
		setLoading(true)
		sessionStorage.setItem("page", (0).toString())
		sessionStorage.setItem("scrollPosition", (0).toString())
		if (link) {
			router.push(link).finally(() => {
				setFiltersLoading(false)
				setLoading(false)
			})
			return
		}

		const paramValues = getParamValuesArray(params, param)

		if (params[param] === defaultValue) {
			paramValues.push(value)
		} else if (paramValues.includes(value)) {
			paramValues.splice(paramValues.indexOf(value), 1)
		} else {
			paramValues.push(value)
		}

		const uniqueParamValues = Array.from(new Set(paramValues))
		if (uniqueParamValues.length === 0) {
			uniqueParamValues.push(defaultValue)
		}

		// Log event to analytics
		reactGA?.event({
			category: gaCategories.eBikefilters,
			action: gaEvents.filterEBikes,
			label: `${param}: ${label}`,
			nonInteraction: false
		})
		const updatedParams = {...params}
		updatedParams[param] = uniqueParamValues.join(",")
		const url = isBrandWorld ? `${filterUrl(updatedParams, param, value, CollectionName.BrandWorld, CollectionName.BrandWorld, brandWorld.brandSlug)}#products-listing` : filterUrl(updatedParams, collectionName, customUrlBaseValue, collectionName)

		router.push(url, undefined, {shallow: true, scroll: false}).then(() => {
			setLoading(false)
			setFiltersLoading(false)
		})
	}

	const filterActive = link ?
		router.asPath === link :
		getParamValuesArray(params, param).includes(value)
	return (
		<>
			<div style={{marginBottom: 8}}
				className={`mb-md-0 d-flex mb-0 w-100 cursor-pointer ${className ? className : ""}`}>
				{isBoxShape ?
					<Checkbox isBoxShape={true}
						id={param}
						isActive={filterActive}
						label={param === "availability" ? t(label, {ns: "filters"}) : label}
						isLoading={loading}
						onChange={handleChange}
						disabled={filtersLoading}
						isSwissMade={isSwissMade}/>		:
					<div style={{marginBottom: 8, width: "100%", ...styles}}
						className={`${className ? className : ""} filters-dropdown-item`}>
						<Checkbox id={param}
							isActive={filterActive}
							className={"cursor-pointer"}
							labelOnly={labelOnly}
							label={param === "availability" ? t(label, {ns: "filters"}) : label}
							isLoading={loading}
							onChange={handleChange}
							disabled={filtersLoading}/>
					</div>
				}
			</div>
		</>
	)
}

FilterDropdownItem.propTypes = {
	label: PropTypes.string.isRequired,
	param: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired
}

export default FilterDropdownItem
